import { Component } from '@angular/core'
import { CellComponent } from '@spartacus/organization/administration/components'
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront'
import { EbOrderDetailsService } from '../../services/facades/eb-order-details.service'

@Component({
    selector: 'eb-order-history-documents-table-download-button',
    templateUrl: './eb-order-history-documents-table-download-button.component.html',
    styleUrls: ['./eb-order-history-documents-table-download-button.component.scss'],
    standalone: false
})
export class EbOrderHistoryDocumentsTableDownloadButtonComponent extends CellComponent {
  constructor(
    public orderDetailsService: EbOrderDetailsService,
    outlet: OutletContextData<TableDataOutletContext>
  ) {
    super(outlet)
  }

  downloadDocument() {
    this.orderDetailsService.downloadDocument(this.model.printDocumentId, this.model.fileName)
  }
}
